import React, { createElement } from 'react';
import DescriptionList from "./DescriptionList";
import { generateModifierClasses } from "../../modules/utils";
const TitledDescriptionList = function ({ titleEl = 'h2', list, modifiers, title }) { const classes = generateModifierClasses('titled-description-list', modifiers); return /*#__PURE__*/ React.createElement("div", { className: classes }, /*#__PURE__*/ createElement(titleEl, null, title), /*#__PURE__*/ React.createElement(DescriptionList, { list: list })); };
export default TitledDescriptionList;
